var map = {
	"./pico-white.svg": 5356,
	"./son-video.svg": 8801,
	"./sony.svg": 1524,
	"./teos.svg": 6405,
	"./testi-cards/01@2x.png": 4781,
	"./testi-cards/02@2x.png": 6201,
	"./testi-cards/03@2x.png": 4492,
	"./testi-cards/aurelio.jpeg": 7824,
	"./testi-cards/maureen.jpeg": 1845,
	"./testi-cards/pico.png": 9209,
	"./testi-cards/sony.png": 8667,
	"./testi-cards/ubisoft.png": 2672,
	"./testi-cards/voila.png": 7135,
	"./testi-cards/white.png": 5277,
	"./tiktok.svg": 8573,
	"./ubisoft.svg": 7754,
	"./voila.svg": 6752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5887;